import * as z from "zod";

import { ZoneUserRole } from "constants/userContstants";

export const userFormSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  profession: z.string().nullable().optional(),
  email: z.string(),
  roles: z.array(z.enum(Object.values(ZoneUserRole))).min(1),
  zones: z.array(z.string()).min(1),
  preferences: z.object({ language: z.string().optional() }).optional(),
  metadata: z.object().optional(),
});

export type UserFormSchema = z.infer<typeof userFormSchema>;
